import React from "react";

import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ReleaseModal = ({
  releaseOpenModal,
  releaseHandleClose,
  WithdrwaHandler,
  wamount,
  setWAmount,
  pcomputingPower,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Modal open={releaseOpenModal} onClose={releaseHandleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#000",
            padding: { md: "2rem 4rem ", xs: "2rem 2rem " },
            height: "auto",
            boxShadow: "0px 0px 8px 1px",
            border: "1px solid black",
            borderRadius: "20px",
            minWidth: { xs: "320px", sm: "400px" },
          }}
        >
          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: { md: "16px", xs: "12px" },
                fontWeight: "400",
                color: "#fff",
                visibility: "hidden",
              }}
            >
              {t("Staking.des").slice(0, 40)}
            </Typography>

            <Box display="flex" justifyContent="space-between" mb={4}>
              <Typography
                sx={{
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontSize: { md: "20px", xs: "15px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                Your Node
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontSize: { md: "20px", xs: "15px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                {pcomputingPower ? pcomputingPower : "0"}
              </Typography>
            </Box>

            <form onSubmit={WithdrwaHandler}>
              <Box display="flex" flexDirection="column" gap={4}>
                <TextField
                  value={wamount}
                  onChange={(e) => setWAmount(e.target.value)}
                  placeholder="Enter release node"
                  type="number"
                  step="1"
                  onKeyPress={(e) => {
                    const charCode = e.which ? e.which : e.keyCode;
                    if (charCode === 46) {
                      e.preventDefault(); // Prevents the decimal character from being entered
                    }
                  }}
                  sx={{ width: "100%" }}
                  InputProps={{
                    sx: {
                      background: "transparent",
                      boxShadow: "0px 0px 5px 1px",
                      color: "#fff",

                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        color: "#fff",
                      },
                    },
                  }}
                />
                <Button
                  type="submit"
                  sx={{
                    border: "2px solid #CB3C35",
                    background: "#CB3C35",
                    borderRadius: "10px",
                    color: "#fff",
                    padding: " 0.7rem 4rem ",
                    textTransform: "none",
                    "&:hover": {
                      background: "#CB3C35",
                    },
                  }}
                  disabled={pcomputingPower <= "0" ? true : false}
                >
                  Release
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ReleaseModal;
